<template lang="html">
	<footer id="footer" class="overlay animated from-top">
		<div class="decor-wrapper">
			<svg id="footer-decor" class="decor top" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 100 100" preserveAspectRatio="none">
				<path class="large left" d="M0 0 L50 50 L0 100" fill="rgba(255,255,255, .1)"></path>
				<path class="large right" d="M100 0 L50 50 L100 100" fill="rgba(255,255,255, .1)"></path>
				<path class="medium left" d="M0 0 L50 50 L0 66.6" fill="rgba(255,255,255, .3)"></path>
				<path class="medium right" d="M100 0 L50 50 L100 66.6" fill="rgba(255,255,255, .3)"></path>
				<path class="small left" d="M0 0 L50 50 L0 33.3" fill="rgba(255,255,255, .5)"></path>
				<path class="small right" d="M100 0 L50 50 L100 33.3" fill="rgba(255,255,255, .5)"></path>
				<path d="M0 0 L50 50 L100 0 L0 0" fill="rgba(255,255,255, 1)"></path>
				<path d="M48 48 L50 51 L52 48 L48 48" fill="rgba(255,255,255, 1)"></path>
			</svg>
		</div>
		<div class="socialize" data-aos="zoom-in">
			<li class="wechat">
				<a class="socialicon"><i class="iconfont">&#xe609;</i></a>
				<div class="wechatimg"><img src="static/images/weixin.jpg"></div>
			</li>
		</div>
        <div class="cr">
            <a href="https://beian.miit.gov.cn" target="_blank" style="color:#939393;">鄂ICP备18020018号-1</a>
        </div>
        <div class="cr">
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42011102002643" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="static/images/beian.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">鄂公网安备 42011102002643号</p></a>
        </div>
	</footer>
</template>
<script>
	export default {
		name: "vFooter"
	}
</script>
<style lang="css" scoped>
    .cr a {
        font-size:12px;
    }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue